import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import IconButton from '@mui/material/IconButton'
import { IUserGroup, IUser_Group } from 'bets.oddprovider.lib.common.ts/models'
import { NumberUtils } from 'fwork-jsts-common/src'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import axios from '../../apiClient/axios'
import { UserGroupsApiClient } from '../../apiClient/userGroups'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { IUserGroupsState, userGroupsStateLoadFromApi } from '../../redux/reducers/userGroups.slice'
import { RootState } from '../../redux/store'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentClickRowProps, TableComponentSetCurrPageProps } from '../common/table/common'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'

const UserGroupItemComponent = (props: {
  group: IUserGroup
}) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState<boolean>()
  const [users, setUsers] = useState<IUser_Group[] | undefined>()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  let getting = false
  const getUsersGroups = async () => {
    if (getting) {
      enqueueSnackbar('Operação em andamento. Aguarde...', { variant: 'success' })
      return
    }
    getting = true

    if (!users)
      try {
        dispatch(toggleLoading())
        const response = await new UserGroupsApiClient(axios).get({
          where: {
            id: props.group.id
          },
          nested: 'users{user}',
          sort: { name: 1 }
        })
        if (response.success && response.data?.payload)
          setUsers(response.data.payload[0].users)
      } catch (error) {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
      }
      finally {
        dispatch(toggleLoading())
        getting = false
      }
    else getting = false
  }

  return <StyledTableCell style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }}
    >
      <StyledListItemText
        style={{ cursor: 'pointer', }} onClick={() => {
          navigate(RoutesNames.userGroup.replace(':id', props.group?.id.toString()))
        }}
        primary={props.group.name}
      />
      <IconButton style={{ height: 46, width: 46 }} size={'small'}
        onClick={(e) => {
          e.stopPropagation()
          getUsersGroups()
          setOpen(!open)
        }}>
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </div>
    {open ? <div>
      {users?.map((user_group, idx) => {
        return <div key={idx}>{user_group?.user?.name}, {user_group?.user?.login}</div>
      })}
    </div> : <></>}
  </StyledTableCell>
}

export const UsersGroupsComponent = () => {
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const userGroupsState: IUserGroupsState = useSelector((state: RootState) => state.userGroups)
  const userGroups = [...userGroupsState?.payload || []]
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [searchText, setSearchText] = useState<string | undefined>()


  const loadUsersGroups = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<IUserGroup> | undefined = searchText ? {
      $or: [
        {
          name: { $regex: searchText, $options: 'i' },
        },
        {
          id: NumberUtils.onlyNumbers(searchText)
        }]
    } : undefined

    const response = await dispatch(userGroupsStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Grupos de usuários'
        onRefreshClick={loadUsersGroups}
        onAddClick={() => navigate(RoutesNames.userGroup)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por código ou nome'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadUsersGroups() }}
        onIconClick={loadUsersGroups}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={userGroups}
        bodyRowBuilder={(userGroup: IUserGroup) => <UserGroupItemComponent group={userGroup} key={userGroup.id} />}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: IUserGroup) => {
            navigate(RoutesNames.userGroup.replace(':id', item?.id.toString()))
          }
        }}
      />
    </div>
  </>
}